import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopComments728x90Fs from './freestar/DesktopComments728x90';
import DesktopComments728x90Tab from './taboola/DesktopComments728x90';
const DesktopComments728x90 = ({ safety = 'off', safetyState })=>{
    const isTaboola = useFlag('ads_taboola');
    if (isTaboola) {
        return /*#__PURE__*/ React.createElement(DesktopComments728x90Tab, {
            safety: safety,
            safetyState: safetyState
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopComments728x90Fs, {
        safety: safety,
        safetyState: safetyState
    });
};
DesktopComments728x90.displayName = 'DesktopComments728x90';
export default DesktopComments728x90;
